/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('RelacionFormAdminController', RelacionFormAdminController);

    /* @ngInject */
    function RelacionFormAdminController($timeout, $state, itemData, Principal, AlertService, Responsable, Lugar,
                                         tipologias, subgeneros, previousParams) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.item = itemData;
        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        //nombre del usuario y rol(para los permisos)
        vm.userName = Principal.identity().$$state.value.login;
        vm.userRole =  Principal.identity().$$state.value.role;

        if (vm.mode === 'edit') {
            Principal.hasAuthority("ROLE_ADMIN").then(function (esAdmin) {
                if (!esAdmin && vm.item.nombreUsuario != vm.userName) {
                    AlertService.warning("admin.relacion.error.unauthorized", null, 0);
                }
            });
        }

        // Guardar formulario
        vm.save = function () {
            if (vm.item.tipologiaPrincipal == null && vm.item.subgeneroPrincipal != null
                || vm.item.tipologiaAlternativa == null && vm.item.subgeneroAlternativo != null) {
                AlertService.warning("admin.relacion.error.subgenerosintipologia");
                return;
            }
            if (vm.mode === 'edit') {
                vm.item.$save().then(function (data) {
                    $state.go('admin/relacion/list', previousParams);
                });
            }
            if (vm.mode === 'create') {
                vm.item.$save().then(function (data) {
                    $state.go('admin/edicion/list', {relacionId: data.id});
                });
            }
        };

        vm.tipologias = tipologias;
        vm.subgeneros = subgeneros;
        vm.responsableService = Responsable;
        vm.lugarService = Lugar;
    }

})(angular);
